import {Component} from '@angular/core';

@Component({
    selector: 'vui-data-grid-error',
    templateUrl: './data-grid-error.component.html',
    styleUrls: ['./data-grid-error.component.scss']
})
export class DataGridErrorComponent {

}
